<template>
    <div :style="inlineBg()"
         :class="{'rounded-full' : !square, 'rounded-md' : square, 'cursor-pointer': lightbox }"
         class="shrink-0 relative inline-flex items-center justify-center bg-center bg-cover bg-gray-100 dark:bg-slate-700 ring-1 ring-gray-300 dark:ring-slate-600"
         v-bind="data"
    >
        <svg-icon v-if="!ava" set="local" icon="fresh-chicken"
                  class="m-1 w-full text-gray-400 dark:text-slate-300 opacity-50"/>

        <div v-if="online" title="online"
             class="bg-green-500 rounded-full w-2 h-2 border border-white absolute bottom-0 right-0"
        ></div>
    </div>
</template>
<script>
export default {
    props: ['ava', 'square', 'lightbox','online'],
    methods: {
        inlineBg() {
            if (!this.ava) {
                return '';
            }

            return {backgroundImage: `url(${this.ava})`};
        },
    },
    computed: {
        data() {
            if (!this.lightbox) {
                return {};
            }

            return {
                'data-src': this.ava,
                'data-fancybox': true,
            }
        }
    }
}
</script>